module.exports = __webpack_public_path__ + "img/empty-black.592d612d.svg";